import { defineHub } from "../classes/HubDefinition";
export default defineHub({
    // #region Run
    name: 'viewer',
    // #endregion
    // #region Core
    async execute(command, args) {
        if (command.address === 'showdocument') {
            return await this.showDocument(command, args);
        }
        else if (command.address === 'loaddocument') {
            return await this.loadDocument(command, args);
        }
        else {
            appHost.notification.showToast("Invalid command '" + command.address + "' in handler '" + this.name + "'.", "warning");
            return this.Cancel();
        }
    },
    // #endregion
    // #region Methods
    methods: {
        async showDocument(command, args) {
            //Run
            let tData = command.data;
            {
                if (!tData.link) {
                    return this.Ok();
                }
            }
            this.$appHost.eventBus.emit('viewer-show', { link: tData.link });
            {
                return this.Ok();
            }
        },
        async loadDocument(command, args) {
            this.$appHost.eventBus.emit('invoke-event', 'viewer-load');
            {
                return this.Ok();
            }
        }
    }
    // #endregion
});
